import { createApi } from '@reduxjs/toolkit/query/react';

import { TAG_PERFORMANCES } from '../../config/tags';
import { HORSES } from '../../config/urls';
import { adaptPerformance } from '../adapters/performances';

import { baseQuery } from './baseQuery';

import type { PerformancesArgs } from './performancesArgs';
import type { ApiPerformance, Performance } from '../types/performance';

export const performancesApi = createApi({
  reducerPath: 'performancesApi',
  tagTypes: [TAG_PERFORMANCES],
  baseQuery,
  endpoints: builder => ({
    getPerformances: builder.query<Performance[], PerformancesArgs>({
      query: ({ horseId, language, size, beforeDate }) => ({
        url: `${HORSES}/${horseId}/performances`,
        params: { language, size, beforeDate },
      }),
      transformResponse: (
        apiPerformances: ApiPerformance[],
        _meta,
        { horseId }: PerformancesArgs
      ): Performance[] =>
        apiPerformances.map(apiPerformance => adaptPerformance(apiPerformance, horseId)),
    }),
  }),
});

export const { useGetPerformancesQuery, useLazyGetPerformancesQuery } = performancesApi;
